import { render } from "./EventConfigForm.vue?vue&type=template&id=5d114fa7&scoped=true"
import script from "./EventConfigForm.vue?vue&type=script&lang=js"
export * from "./EventConfigForm.vue?vue&type=script&lang=js"

import "./EventConfigForm.vue?vue&type=style&index=0&id=5d114fa7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d114fa7"]])

export default __exports__